import { Directive, ElementRef, Input, NgZone, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';

import { AOAuthService } from '../../services/ao-auth.service';
import { AOSubscriptions } from '../../utils/ao-subscriptions';

@Directive({
  selector: '[ao-is-guest]'
})
export class AOIsGuestDirective implements OnInit, OnDestroy {

  private _subscriptions: AOSubscriptions = new AOSubscriptions();

  @Input() aoIsGuest;

  constructor(
    private _element: ElementRef,
    private _templateRef: TemplateRef<any>,
    private _viewContainer: ViewContainerRef,
    private _zone: NgZone
  ) {
  }

  ngOnInit() {
    this._subscriptions.add('status', AOAuthService._onChange.subscribe(status => {
      this._zone.run(() => {
        status
          ? this._viewContainer.clear()
          : this._viewContainer.createEmbeddedView(this._templateRef);
      });
    }));
  }

  ngOnDestroy() {
    this._subscriptions.stop();
  }

}
